import { useEffect } from 'react';
export default function usePreventTouchMove(dom: HTMLDivElement) {
  useEffect(() => {
    function handleTouchMove(e: Event) {
      e.preventDefault();
    }
    dom && dom.addEventListener('touchmove', handleTouchMove, false);
    return () => {
      dom && dom.removeEventListener('touchmove', handleTouchMove);
    };
  }, [dom]);
}
